/** Typy kriviek */
export enum CurveTypes {

  left = 0,
  right = 1

}
